(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    // Only auto-scroll to the product card anchor when navigating back/forward.
    // Otherwise, a URL with a fragment (or a persisted fragment) can land the user mid-page.
    const navEntry = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
    const isBackForward =
      (navEntry && navEntry.type === 'back_forward') ||
      (performance.navigation && performance.navigation.type === 2);
    const expectedPrefix = '#{{ section.id }}-';
    const isDesktop = matchMedia('(min-width: 750px)').matches;

    if (isDesktop && isBackForward && url.hash.startsWith(expectedPrefix)) {
      document.addEventListener(
        'DOMContentLoaded',
        () => {
          const card = document.getElementById(url.hash.slice(1));
          if (card) {
            card.scrollIntoView({ behavior: 'instant' });
          }
        },
        { once: true }
      );
    }
  }

  } catch(e) { console.error(e); }
})();
})();
